import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { onboarding as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    customStepWeighting: null,
    components: {
      Acquisition: () => null,
    },
    checkShouldShowAcquisitionStep: () => false,
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
